import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { createEvent, createStore } from 'effector'
import { List, ListItem, ListItemText } from '@mui/material';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '15px',
    flexDirection: 'column',
    transform: 'translate(-50%, -50%)',
    'max-width': '600px',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

export const updateModal = createEvent()
export const successModal = createEvent()

export default function ErrorModal() {

    const unpackErrors = (errors) =>
        errors.map(error => [
            error.message,
            ...unpackErrors(error.subErrors || [])
        ])
            .flat()
            .filter(msg => msg.length);

    createStore(null).on(updateModal, (_, errors) => {
        if (!errors?.length) {
            return;
        }

        errors = unpackErrors(errors);
        setErrors(errors)
        errors.length && handleOpen()
    })
    createStore(null).on(successModal, (_, error) => {
        setModalSText(error)
        handleSOpen()
    })
    const [errors, setErrors] = React.useState([])
    const [open, setOpen] = React.useState(false);
    const handleClose = () => setOpen(false);
    const handleOpen = () => {
        setOpen(true);
    }
    const [modalSText, setModalSText] = React.useState()
    const [Sopen, setSOpen] = React.useState(false);
    const handleSClose = () => setSOpen(false);
    const handleSOpen = () => {
        setSOpen(true);
    }

    return (
        <>
            <Modal
                open={open}
                onClose={handleClose}
            >
                <Box sx={style}>
                    <Typography variant="h6" component="h2">
                        Ошибки:
                    </Typography>
                    <List dense sx={{ listStyleType: 'disc' }}>
                        {errors.map((err, i) => (
                            <ListItem sx={{ display: 'list-item' }} key={i}>
                                <ListItemText>
                                    {err}
                                </ListItemText>
                            </ListItem>
                        ))}
                    </List>
                    <Button
                        onClick={handleClose}
                        variant="contained"
                    >
                        Закрыть
                    </Button>
                </Box>
            </Modal>
            <Modal
                open={Sopen}
                onClose={handleSClose}
            >
                <Box sx={style}>
                    <Typography variant="h6" component="h2">
                        {modalSText}
                    </Typography>
                    <Button
                        onClick={handleSClose}
                        variant="contained"
                    >
                        Закрыть
                    </Button>
                </Box>
            </Modal>
        </>
    )
}